var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup25309(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 212.178,
    height: 145.525,
    viewBox: "0 0 212.178 145.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25309",
    "data-name": "Group 25309",
    transform: "translate(-184.813 -1160.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54126",
    "data-name": "Path 54126",
    d: "M393.247,1233.47c15.285-50.894-18.072-89.937-66.618-66.045-46.123,22.67-114.516,1.088-136.271,36.238C170.8,1235.3,202.8,1306.806,289.3,1305.737c58.641-.725,87.075-16.106,103.944-72.267Z",
    transform: "translate(0)",
    fill: "#efefef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25307",
    "data-name": "Group 25307",
    transform: "translate(232.052 1182.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54127",
    "data-name": "Path 54127",
    d: "M491.842,1382.638l.439,6.545c-5.057,9.35-16.621,9.637-21.736.21l.439-6.908a16.1,16.1,0,0,0,20.858.153Z",
    transform: "translate(-427.817 -1334.688)",
    fill: "#c46c5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54128",
    "data-name": "Path 54128",
    d: "M337.173,1510.545c-3.168,12.423-3.511,24.331,1.527,25.113H373.43l-9.732-16.774a74.485,74.485,0,0,1-26.525-8.339Z",
    transform: "translate(-334.843 -1422.426)",
    fill: "#e28775",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54129",
    "data-name": "Path 54129",
    d: "M588.541,1510.545c3.187,12.423,3.53,24.331-1.508,25.113H552.3l9.713-16.774a74.485,74.485,0,0,0,26.525-8.339Z",
    transform: "translate(-483.832 -1422.426)",
    fill: "#e28775",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54130",
    "data-name": "Path 54130",
    d: "M378.114,1403.968c-10.667,1.317-26.372,3.492-31.983,12.48-3.282,5.248-8.549,12.614-10.5,19.789a75.121,75.121,0,0,0,28.605,9.484l9.732,16.774h9.98l4.961-.019,4.942.019h10l9.713-16.774a74.908,74.908,0,0,0,28.605-9.484c-1.927-7.175-7.213-14.541-10.477-19.789-5.61-8.988-21.182-11.354-31.849-12.69-5.057,9.35-16.621,9.637-21.736.21Z",
    transform: "translate(-335.386 -1349.263)",
    fill: "#26a7df",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54131",
    "data-name": "Path 54131",
    d: "M436.929,1258.12c-.42-6.011.839-13.969,6.278-18.911.1-1.66.534-4.141,1.794-5.248.916-.821,1.946,2.481,3.091,2,1.355-.592.4-3.626,1.813-4.1,1.2-.4,1.584,2.824,2.805,2.557,1.45-.324,1.011-3.435,2.462-3.721,1.2-.248,2.233,3.015,3.454,3,6.278-.076,12.251,2.176,13.568,7,9.961.821,6.679,12.785,6.412,21.754-14.331-.973-27.326-3.359-41.677-4.332Z",
    transform: "translate(-404.734 -1230.684)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54132",
    "data-name": "Path 54132",
    d: "M559.875,1307.333a4.541,4.541,0,0,1,4.542,4.542c0,2.519-2.023,6.374-4.542,6.374-2.5,0-4.542-3.855-4.542-6.374a4.553,4.553,0,0,1,4.542-4.542Z",
    transform: "translate(-485.908 -1283.199)",
    fill: "#c46c5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54133",
    "data-name": "Path 54133",
    d: "M431.087,1307.333a4.541,4.541,0,0,0-4.542,4.542c0,2.519,2.023,6.374,4.542,6.374,2.5,0,4.542-3.855,4.542-6.374a4.553,4.553,0,0,0-4.542-4.542Z",
    transform: "translate(-397.671 -1283.199)",
    fill: "#c46c5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54134",
    "data-name": "Path 54134",
    d: "M462.874,1261.818A19.522,19.522,0,0,1,482.4,1281.34c0,10.8-8.74,22.384-19.522,22.384-10.8,0-19.541-11.583-19.541-22.384a19.526,19.526,0,0,1,19.541-19.522Z",
    transform: "translate(-409.173 -1252.015)",
    fill: "#e28775",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54137",
    "data-name": "Path 54137",
    d: "M457.6,1251.443c-4.828.878-13.434,8.74-12.442,17.5,2.977,1.965,20.953-1.7,25.876-9.064,6.832.229,5.8,9.1,11.927,9.064a13.639,13.639,0,0,0-5.191-13.148c-5.362-4.313-13.415-5.591-20.171-4.351Z",
    transform: "translate(-410.372 -1244.599)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25308",
    "data-name": "Group 25308",
    transform: "translate(244.808 1251.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54144",
    "data-name": "Path 54144",
    d: "M416.3,1495.256H382.9a5,5,0,0,1-4.828-4.828l-2.71-34.044a4.7,4.7,0,0,1,4.809-4.809H452.4a4.683,4.683,0,0,1,4.809,4.809l-2.71,34.044a4.988,4.988,0,0,1-4.828,4.828Z",
    transform: "translate(-375.353 -1451.576)",
    fill: "#d8d9d9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54145",
    "data-name": "Path 54145",
    d: "M497.712,1520.515a3.53,3.53,0,1,0-3.53-3.53,3.547,3.547,0,0,0,3.53,3.53Z",
    transform: "translate(-456.767 -1493.971)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54146",
    "data-name": "Path 54146",
    d: "M384.7,1457.878c-1.049.019-2.137,2.08-1.088,2.118,24.617.725,52.363.82,76.98.1,1.45-.038-2.08-2.118-3.53-2.156q-36.152-1.059-72.362-.057Z",
    transform: "translate(-380.722 -1455.55)",
    fill: "#fefefe",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_54147",
    "data-name": "Path 54147",
    d: "M213.24,1590.3H393.591a2.626,2.626,0,0,1,2.633,2.623v4.843a2.643,2.643,0,0,1-2.633,2.642H213.24a2.643,2.643,0,0,1-2.634-2.642v-4.843a2.627,2.627,0,0,1,2.634-2.623Z",
    transform: "translate(-17.672 -294.661)",
    fill: "#0b3454",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup25309);
export default __webpack_public_path__ + "static/media/group-25309.f10129498c9cfa1f2d70708b9a05f9c9.svg";
export { ForwardRef as ReactComponent };